/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Restore_Success_ContentInputs */

const en_dialog_restore_success_content = /** @type {(inputs: Dialog_Restore_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep enjoying Plus features!`)
};

const ar_dialog_restore_success_content = /** @type {(inputs: Dialog_Restore_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استمر في الاستمتاع بميزات بلس!`)
};

const de_dialog_restore_success_content = /** @type {(inputs: Dialog_Restore_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genießen Sie weiterhin die Plus-Funktionen!`)
};

const es_dialog_restore_success_content = /** @type {(inputs: Dialog_Restore_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Sigue disfrutando de las funciones Plus!`)
};

const fr_dialog_restore_success_content = /** @type {(inputs: Dialog_Restore_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuez à profiter des fonctionnalités de Plus!`)
};

const it_dialog_restore_success_content = /** @type {(inputs: Dialog_Restore_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua a usufruire delle funzionalità Plus!`)
};

const ja_dialog_restore_success_content = /** @type {(inputs: Dialog_Restore_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引き続きPlusの機能をお楽しみください！`)
};

const ko_dialog_restore_success_content = /** @type {(inputs: Dialog_Restore_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 기능을 계속 즐기세요!`)
};

const pt_br_dialog_restore_success_content = /** @type {(inputs: Dialog_Restore_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue aproveitando as funcionalidades Plus`)
};

const ru_dialog_restore_success_content = /** @type {(inputs: Dialog_Restore_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжайте пользоваться функциями Plus!`)
};

const th_dialog_restore_success_content = /** @type {(inputs: Dialog_Restore_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพลิดเพลินไปกับคุณสมบัติ Plus ต่อไป!`)
};

const tr_dialog_restore_success_content = /** @type {(inputs: Dialog_Restore_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus özelliklerinin keyfini çıkarmaya devam et!`)
};

const zh_cn_dialog_restore_success_content = /** @type {(inputs: Dialog_Restore_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续享受 Plus 功能！`)
};

const zh_tw_dialog_restore_success_content = /** @type {(inputs: Dialog_Restore_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繼續享受 Plus 功能！`)
};

/**
* | output |
* | --- |
* | "Keep enjoying Plus features!" |
*
* @param {Dialog_Restore_Success_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_restore_success_content = /** @type {((inputs?: Dialog_Restore_Success_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Restore_Success_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_restore_success_content(inputs)
	if (locale === "ar") return ar_dialog_restore_success_content(inputs)
	if (locale === "de") return de_dialog_restore_success_content(inputs)
	if (locale === "es") return es_dialog_restore_success_content(inputs)
	if (locale === "fr") return fr_dialog_restore_success_content(inputs)
	if (locale === "it") return it_dialog_restore_success_content(inputs)
	if (locale === "ja") return ja_dialog_restore_success_content(inputs)
	if (locale === "ko") return ko_dialog_restore_success_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_restore_success_content(inputs)
	if (locale === "ru") return ru_dialog_restore_success_content(inputs)
	if (locale === "th") return th_dialog_restore_success_content(inputs)
	if (locale === "tr") return tr_dialog_restore_success_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_restore_success_content(inputs)
	return zh_tw_dialog_restore_success_content(inputs)
});